@if (showErrors) {
  <small class="bb-input-validation-message" [attr.role]="role" [attr.id]="messageId || null">
    @if (showIcon) {
      <bb-icon-ui class="bb-input-validation-message__icon" name="error-outline" size="sm"></bb-icon-ui>
    }
    <ng-content></ng-content>
  </small>
}
